import { useQuery } from "@tanstack/react-query";

import HomeService from "@/services/HomeService";

// ---- data normalization (walks-by-theme-location endpoint) -----------------
const asArray = (v) => (Array.isArray(v) ? v : []);

const buildLocation = (w) =>
    w?.location ||
    [w?.city_name, w?.state_name, w?.country_name].filter(Boolean).join(", ") ||
    "";

// Maps the API's type marker to the join modal's expected value.
const resolveJoinType = (w) => {
    const t = String(w?.walk_type ?? w?.type ?? "").toLowerCase();
    if (t.includes("group") || w?.is_group_walk || w?.group_walk) return "group-walks";
    return "walks";
};

const normalizeWalk = (w = {}, i = 0) => ({
    ...w,
    id: w.id ?? `walk-${i}`,
    name: w.name ?? w.title ?? "",
    hostedBy: w.walk_hosted_by ?? "",
    description: w.description ?? "",
    location: buildLocation(w),
    image: w.logo_url ?? w.banner_url ?? asArray(w.image_urls)[0] ?? "",
    joinType: resolveJoinType(w),
});

const buildLocationLabel = (loc) =>
    loc ? [loc.city, loc.state, loc.country].filter(Boolean).join(", ") : "";

// Shapes the endpoint payload into what the drawer renders.
const normalize = (data) => ({
    theme: data?.theme ?? null,
    location: data?.location ?? null,
    locationLabel: buildLocationLabel(data?.location),
    matchedBy: data?.matched_by ?? null,
    count: Number(data?.walks_count ?? asArray(data?.walks).length) || 0,
    walks: asArray(data?.walks).map(normalizeWalk),
});

const useThemeWalks = (themeId, enabled = true) =>
    useQuery({
        queryKey: ["walks-by-theme-location", themeId],
        // httpService resolves even on API errors, so surface a failure here
        // to drive react-query's error/retry state.
        queryFn: async () => {
            const res = await HomeService.getWalksByThemeLocation({ theme_id: themeId });
            if (res?.success === false) throw new Error(res?.message || "Failed to load walks");
            return normalize(res?.data ?? {});
        },
        enabled: Boolean(enabled) && themeId != null,
        staleTime: 5 * 60 * 1000,
    });

export default useThemeWalks;
